import React, { SyntheticEvent, useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../types/upload-field'
import { UploadFieldBlock } from '../../blocks'
import Instructions from '../field-instructions'
import Title from '../field-title'
import { CreationToolUploadContext } from '../manager'

const Container = styled(UploadFieldBlock as any)`
    grid-column: span 4;
`

type Props = {
    className?: string
    field: CreationToolUploadField
    sourceId?: string
}

const CreationUploadDescriptionField = ({ className, field, sourceId }: Props) => {
    const { uploadSources, updateUploadSource, description, setDescription } = useContext(CreationToolUploadContext)
    const [displayDescription, setDisplayDescription] = useState<string>('')
    const placeholder = CreationToolUploadField.description(field)
    const maxLength = CreationToolUploadField.maxCharacterCount(field)

    useEffect(() => {
        if (sourceId) {
            const source = uploadSources.find(src => src.id === sourceId)
            source && setDisplayDescription(source.description || '')
        } else {
            setDisplayDescription(description)
        }
    }, [uploadSources, sourceId, description])

    const onInput = (e: SyntheticEvent<HTMLTextAreaElement, InputEvent>) => {
        const newDescription = e.currentTarget.value || ''
        if (sourceId) {
            const source = uploadSources.find(src => src.id === sourceId)
            source && updateUploadSource({ ...source, description: newDescription })
        } else {
            setDescription(newDescription)
        }
    }

    return (
        <Container className={className}>
            <Title field={field}>{uploadSources.length > 1 && !sourceId && ` (Bulk)`}</Title>
            <textarea
                {...{
                    defaultValue: displayDescription,
                    placeholder: sourceId ? description || placeholder : placeholder,
                    maxLength: maxLength || undefined,
                    onInput,
                }}
            />
            <Instructions field={field} />
        </Container>
    )
}

export default CreationUploadDescriptionField
